import React from 'react';
import Slide from 'react-reveal/Slide';

import 'bootstrap/dist/css/bootstrap.min.css';
import LandingPage from '../../components/LandingPage/landingpage';
import Difference from  '../../components/Difference/difference';
import About from '../../components/About/about';
import Form from '../../components/Form/form';
import Footer from '../../components/Footer/footer';
import WAM from '../../components/assets/whatsapp.svg';

function Home(props) {
  return (
    <>
      <LandingPage {...props}/>
      <Difference />
      <About />
      <Form />
      <Footer />
      <Slide right delay={2500}>
        <a href="https://wa.me/2348162898892?text=Hello%20Bitmasta!" className="whatsapp">
          <img src={WAM} alt="whatsapp"/>
        </a>
      </Slide>
    </>
  );
}

export default Home;
